export class mailBuilderAPI {

  clientId: number;
  constructor(clientId: number) {
    this.clientId = clientId;
  }
  async getMailingList(id?: number) {
    const mailinglist = await $fetch('/api/client/mail-builder/mailinglist',{
      headers:useRequestHeaders(['cookie']),
      params: {
        id: id
      }
  })
    return mailinglist
  }
}